export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS";